import type { components } from '../../Types/api';

export type ReleaseNewsItem = components['schemas']['Cockpit.Services.ReleaseNews.ReleaseNewsItem'];

export const NEW_RELEASE_NEWS_ID = 'new';

export interface ReleaseNewsForm {
    id: string;
    changed: boolean;
    data?: ReleaseNewsItem | null;
}

export interface RootState {
    CommonReducer: { forms?: { releaseNewsForm?: ReleaseNewsForm }; dataLoading?: Record<string, boolean> };
    SettingsReducer: { releaseNews?: ReleaseNewsItem[] | null };
}
